import { Spin } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';

import './index.scss';
import MedNegModal from './MedNegModal';
import medNegStore from './MedNegStore';
import MedNegToolbar from './MedNegToolbar';
import MedNegTable from './MedNegTable';

window.reloadMedNeg = () => {
  medNegStore.refetch({}, true);
};
@observer
class MedNeg extends React.Component {
  componentDidMount() {
    medNegStore.fetchFiles(true);
    medNegStore.fetchDynamicMedNegNextTask();
  }

  render() {
    const {
      loading,
      data,
      open,
      dataClaimant,
      loadingClaimant,
      loadingDynamicMNStatus,
      loadingStaff,
      loadingDynamicOverDueMNStatus,
      loadingStaffAssign,
      loadingStaffAssignAction,
      dataDynamicMedNegStatus,
      dataDynamicOverDueMedNegStatus,
      dataStaff,
      dataStaffAssign,
      dataStaffAssignAction,
    } = medNegStore;
    return (
      <div className={`Table-${loading && !data ? 'loading' : 'container'}`}>
        {(loading && !data) ||
        (loadingClaimant && !dataClaimant) ||
        (loadingDynamicMNStatus && !dataDynamicMedNegStatus) ||
        (loadingStaff && !dataStaff) ||
        (loadingDynamicOverDueMNStatus && !dataDynamicOverDueMedNegStatus) ||
        (loadingStaffAssign && !dataStaffAssign) ||
        (loadingStaffAssignAction && !dataStaffAssignAction) ? (
          <Spin size="large" />
        ) : (
          <React.Fragment>
            <MedNegToolbar />
            <MedNegTable />
            {open && <MedNegModal />}
          </React.Fragment>
        )}
      </div>
    );
  }
}

export default MedNeg;
